
// const lastSeenWithin15Mins = (dateTime) => dateTime ? new Date() - new Date(dateTime) < (60000 * 15) : false
const lastSeenWithin20Mins = (dateTime) => dateTime ? new Date() - new Date(dateTime) < (60000 * 20) : false

const isOnlineOrRecent = (user) => {
  const onStatus = {
    isOnline: false,
    isRecent: false,
  }
  if (user?.lastOnlineAt) {
    onStatus.isOnline = true
    onStatus.isRecent = true
    return onStatus
  } else if (lastSeenWithin20Mins(user?.lastSeenAt)) {
    onStatus.isRecent = true
    return onStatus
  } else {
    return onStatus
  }
}

export { isOnlineOrRecent }
